import React, { Component } from 'react';
import { Button, ButtonToolbar, Form, FormGroup, ControlLabel, Modal, FormControl, HelpBlock } from 'react-bootstrap';
import Select from "react-select";

import { MapPointStops } from '../mapPointStops/MapPointStops';

export class MapPointForm extends Component {
    constructor(props) {
        super(props);

        this.state = {
            showMapPointStops: false,

            mapPoint: this.props.mapPoint,
            nameInputError: null,
            latitudeInputError: null,
            longitudeInputError: null,
        }
    }

    // -----------------

    handleManageStops() {
        this.setState({ 
            showMapPointStops: true 
        });
    }

    onMapPointStopsExit() {
        this.setState({ 
            showMapPointStops: false 
        });
    }

    onChangeValue(e, property) {
        const { mapPoint } = this.state;

        mapPoint[property] = e.target.value;

        this.setState({
            mapPoint: mapPoint
        });
    }

    onSelectValue(e, property) {
        const { mapPoint } = this.state;

        mapPoint[property] = e;

        this.setState({
            mapPoint: mapPoint
        });
    }
    
    onChangeStopValue(e) {
        const { stops } = this.props;
        const { mapPoint } = this.state;

        mapPoint.stops = stops.filter(stop => undefined !== e.find(select => select.value === stop.id));

        this.setState({
            mapPoint: mapPoint,
        });
    }

    onSave() {
        if (this.validInput()) {
            const { mapPoint } = this.state;
            this.props.onSave(mapPoint);
        }
    }

    validInput() {
        let errors = 0;
        let nameInputError = null;
        let latitudeInputError = null;
        let longitudeInputError = null;

        const { mapPoint } = this.state;

        if ("" === mapPoint.name || null === mapPoint.name || undefined === mapPoint.name) {
            nameInputError = 'error';
            errors++;
        }

        if ("" === mapPoint.latitude || null === mapPoint.latitude || undefined === mapPoint.latitude || isNaN(mapPoint.latitude)) {
            latitudeInputError = 'error';
            errors++;
        }

        if ("" === mapPoint.longitude || null === mapPoint.longitude || undefined === mapPoint.longitude || isNaN(mapPoint.longitude)) {
            latitudeInputError = 'error';
            errors++;
        }

        this.setState({
            nameInputError: nameInputError,
            latitudeInputError: latitudeInputError,
            longitudeInputError: longitudeInputError,
        });

        return errors > 0 ? false : true;
    }

    calculateMapPointCoordinates() {
        const { mapPoint } = this.state;

        if (undefined === mapPoint || 0 === mapPoint.stops.length) {
            mapPoint.latitude = 0.0;
            mapPoint.longitude = 0.0;
        } else {
            let stopsLat = 0;
            let stopsLon = 0;

            mapPoint.stops.forEach((stop) => {
                stopsLat += undefined !== stop.latitude ? stop.latitude : 0.0;
                stopsLon += undefined !== stop.longitude ? stop.longitude : 0.0;
            });

            mapPoint.latitude = stopsLat / mapPoint.stops.length;
            mapPoint.longitude = stopsLon / mapPoint.stops.length;
        }

        this.setState({
            mapPoint: mapPoint
        });
    }

    // -----------------------------------

    render() {
        const { mapPoint, nameInputError, latitudeInputError, longitudeInputError, showMapPointStops } = this.state;

        if (undefined === mapPoint || null === mapPoint) {
            return null;
        }

        const { title, stops, interfaces } = this.props;

        return (
            <Modal show={true}>
                <Modal.Header>
                    <Modal.Title>
                        {title}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <FormGroup controlId="formName" validationState={nameInputError}>
                            <ControlLabel>Nome</ControlLabel>
                            <FormControl
                                type="text"
                                value={mapPoint.name}
                                placeholder="Introduza o nome"
                                onChange={(e) => this.onChangeValue(e, 'name')}
                            />
                            {nameInputError !== null
                                ?
                                <HelpBlock> Este campo não pode estar vazio. </HelpBlock>
                                :
                                null
                            }
                        </FormGroup>

                        <FormGroup controlId="formLatitude" validationState={latitudeInputError}>
                            <ControlLabel>Coordenada X</ControlLabel>
                            <FormControl
                                type="number"
                                value={mapPoint.latitude}
                                placeholder="Introduza a coordenada Latitude"
                                onChange={(e) => this.onChangeValue(e, 'latitude')}
                            />
                            {latitudeInputError !== null
                                ?
                                <HelpBlock> Este campo não pode estar vazio. </HelpBlock>
                                :
                                null
                            }
                        </FormGroup>

                        <FormGroup controlId="formLongitude" validationState={longitudeInputError}>
                            <ControlLabel>Coordenada Y</ControlLabel>
                            <FormControl
                                type="number"
                                value={mapPoint.longitude}
                                placeholder="Introduza a coordenada Y"
                                onChange={(e) => this.onChangeValue(e, 'longitude')}
                            />
                            {longitudeInputError !== null
                                ?
                                <HelpBlock> Este campo não pode estar vazio. </HelpBlock>
                                :
                                null
                            }
                        </FormGroup>

                        <FormGroup controlId="formAddInfo">
                            <ControlLabel>Informação Adicional</ControlLabel>
                            <FormControl
                                type="text"
                                value={mapPoint.addInfo}
                                placeholder="Introduza a informação adicional"
                                onChange={(e) => this.onChangeValue(e, 'addInfo')}
                            />
                        </FormGroup>

                        <FormGroup controlId="formInterfaces">
                            <ControlLabel>Interfaces</ControlLabel>
                            <Select
                                className="custom-multiselect"
                                placeholder='Selecione...'
                                onChange={(e) => this.onSelectValue(e, 'interfaces')}
                                options={interfaces}
                                isMulti={true}
                                isOptionSelected={function (a, b) {
                                    if (undefined !== mapPoint.interfaces) {
                                        return mapPoint.interfaces.map(i => i.id).includes(a.id);
                                    }
                                }}
                                getOptionValue={value => value}
                                getOptionLabel={label => label.namePt}
                                value={mapPoint.interfaces}
                            />
                        </FormGroup>

                    </Form>

                    <ButtonToolbar>
                        <Button onClick={() => this.handleManageStops()}> GERIR PARAGENS ASSOCIADAS </Button>
                        <Button onClick={() => this.calculateMapPointCoordinates()}> CALCULAR COORDENADAS </Button>
                        <Button className="btns-two-lines-small-screens-inside-modal" onClick={() => this.onSave()}> GUARDAR ALTERAÇÕES </Button>
                        <Button className="margin-top-10 btns-two-lines-small-screens-inside-modal" onClick={() => this.props.onHide()}> CANCELAR </Button>
                    </ButtonToolbar>

                    <MapPointStops 
                        show={showMapPointStops} 
                        mapPoint={mapPoint} 
                        stops={stops} 
                        onChangeStopValue={(a) => this.onChangeStopValue(a)} 
                        onHide={() => this.onMapPointStopsExit()} />
                </Modal.Body>
            </Modal>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/datamanager/mapPoints/transportAuthorityMapPoints/MapPointForm.js